'use strict';

const Backbone = require('backbone');
const _ = require('lodash');
const registry = require('../widgets.js');

const Configuration = Backbone.Model.extend({

    getProps: function () {
        const me = this;
        return me.get('props') || {};
    },

    save: function (attrs, options) {
        const me = this;
        options = options || {};
        const successFn = options.success;
        options.success = function () {
            if (me.parent) {
                // Find serialized definition in parent configuration and
                // update it. This way when we reload the model from cache we
                // will reflect the changes
                const idx = _.findIndex(me.parent.attributes.definitions, {
                    instanceId: me.id
                });
                me.parent.attributes.definitions[idx] = _.clone(me.attributes);
            }

            if (successFn) {
                successFn.apply(arguments);
            }
        };

        return Backbone.Model.prototype.save.call(me, attrs, options);
    },

    _removeWidget: function (child, options) {
        const me = this;
        const definitions = _.reject(me.get('definitions'), {
            instanceId: child.instanceId
        });
        me.set('definitions', definitions, options);

        if (me.widgetsCached()) {
            me._widgetsCache.remove(child);
        }
    },

    getWidgets: function (curation) {
        const me = this;

        if (!me.widgetsCached()) {
            me._widgetsCache = registry.build(curation, me.get('definitions'));
        }

        return me._widgetsCache;
    },

    widgetsCached: function () {
        const me = this;
        return Boolean(me._widgetsCache);
    },

    resetWidgetCache: function () {
        const me = this;
        me._widgetsCache = null;
    },

    buildWidget: function (curation, widgetId) {
        return registry.build(curation, {
            widgetId: widgetId,
            props: _.extend({}, curation.getProps())
        });
    },

    appendDefinition: function (child, options) {
        const me = this;

        options = options || {};
        options.url = `${me.url()}/definitions`;
        options.attrs = options.attrs || child.toJSON();
        options.subresource = true;

        return (me.sync || Backbone.sync).call(me, 'create', me, options);
    },

    removeDefinition: function (child, options) {
        const me = this;

        options = _.extend({
            validate: true,
            method: 'delete'
        }, options);

        // NOTE If wait is not true, remove definition synchronously
        if (!options.wait) {
            me._removeWidget(child, options);
        }

        options.url = `${me.url()}/definitions/${child.instanceId}`;

        options.success = function (resp) {
            // NOTE set definitions to server response
            me.set('definitions', resp.definitions, options);
            me.trigger('sync', me, resp, options);
        };

        return (me.sync || Backbone.sync).call(me, 'delete', me, options);
    }
});

module.exports = Configuration;
